import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import SearchIcon from '@tradera/blueprint/theme/icons2/search.svg?jsx';

export const SearchButton = ({ showSearch, onClick }) => {
    const { t } = useTranslator();

    return (
        <button
            className={`btn btn-auto btn-round mx-1 ${
                showSearch ? 'btn-branded' : 'bg-white'
            }`}
            aria-label={t('siteHeader_search')}
            title={t('siteHeader_search')}
            onClick={onClick}
            aria-hidden="true">
            <SearchIcon className="icon icon-md align-text-bottom" />
        </button>
    );
};
